export interface ServicesIntroductionProps {
  content: string;
  phoneNumber: string;
  className?: string;
}

export function ServicesIntroduction({ 
  content,
  phoneNumber,
  className = '' 
}: ServicesIntroductionProps) {
  return (
    <section className={`py-16 px-4 bg-gray-50 ${className}`}>
      <div className="max-w-4xl mx-auto text-center">
        {/* Main Heading */}
        <h1 
          className="text-4xl md:text-5xl font-bold mb-8 leading-tight"
          style={{ 
            fontFamily: 'Poppins, "Poppins Fallback", sans-serif',
            textTransform: 'uppercase',
            lineHeight: '1.2'
          }}
        >
          <span className="text-gray-800">Professional </span>
          <span className="text-red-600">Auto Collision Repair</span>
          <span className="text-gray-800"> Services</span>
        </h1>
        
        {/* Content Text */}
        <div 
          className="text-lg md:text-xl text-gray-700 leading-relaxed max-w-3xl mx-auto"
          style={{ 
            fontFamily: 'Open Sans, "Open Sans Fallback", sans-serif',
            lineHeight: '1.6'
          }}
        >
          {content.split(phoneNumber).map((part, index) => (
            <span key={index}>
              {part}
              {index < content.split(phoneNumber).length - 1 && (
                <span className="font-bold text-red-600">{phoneNumber}</span>
              )}
            </span>
          ))}
        </div>
      </div>
    </section>
  );
}